const link = {
  movie: {
    home: '/',
    detail: '/detail-movie',
    login: '/login',
    register: '/register'
  }
}

export default link
